import { useRouter } from 'next/router'

function Logo() {
  const router = useRouter()
  return (
    <>
      {router.query.lang.toLowerCase() === 'de-de' ||
      router.query.lang.toLowerCase() === 'de-at' ||
      router.query.lang.toLowerCase() === 'de-ch' ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="122" height="25" viewBox="0 0 122 25">
          <path
            fill="#FFF"
            d="M26.15,1 L32.35,1 L26.91,24.3 L19.91,24.3 L16.32,9.48 L12.7,24.3 L6.17,24.3 L0.76,1 L7.51,1 L10.52,15.52 L13.65,1 L19.59,1 L23,15.65 L26.15,1 Z M46.61,0.96 L53.36,0.96 L53.36,24.29 L46.61,24.29 L46.61,0.96 Z M69.38,1 L69.38,24.3 L86,24.3 L86,19.14 L76,19.14 L76,14.9 L83.54,14.9 L83.54,10.13 L76,10.13 L76,6.13 L85.46,6.13 L85.46,1 L69.38,1 Z M115.78,1 L115.78,14.11 L108.31,1 L100.77,1 L100.77,24.3 L106.64,24.3 L106.64,9.64 L115.16,24.29 L121.62,24.29 L121.62,1 L115.78,1 Z"
          />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="24" viewBox="0 0 148 19">
          <g fill="#FEFEFE" fillRule="evenodd">
            <polygon points="13.204 0 9.439 12.946 5.7 0 0 0 6.112 18.439 12.121 18.439 18.156 0" />
            <polygon points="29.452 18.439 34.79 18.439 34.79 0 29.452 0" />
            <polygon points="47.555 0 47.555 18.439 60.708 18.439 60.708 14.364 52.816 14.364 52.816 11.011 58.774 11.011 58.774 7.247 52.816 7.247 52.816 4.074 60.295 4.074 60.295 0" />
            <polygon points="84.305 0 84.305 10.393 78.399 0 72.441 0 72.441 18.439 77.083 18.439 77.083 6.86 83.814 18.439 88.921 18.439 88.921 0" />
            <polygon points="113.446 0 113.446 10.393 107.54 0 101.583 0 101.583 18.439 106.225 18.439 106.225 6.86 112.956 18.439 118.063 18.439 118.063 0" />
            <path d="M135.1863,0.0002 L129.2803,18.4392 L134.2063,18.4392 L135.1863,15.0092 L141.2983,15.0092 L142.2783,18.4392 L147.8743,18.4392 L142.0213,0.0002 L135.1863,0.0002 Z M138.2553,4.2802 L140.2673,11.3722 L136.2173,11.3722 L138.2553,4.2802 Z" />
          </g>
        </svg>
      )}
    </>
  )
}

export default Logo
